// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --dark-color: #2b2b2b;
  --dark-icon-color: #fff;
  --light-color: #f7f7f7;
  --light-icon-color: #ffde59;
}

.dm_btn {
  background-color: #fff !important;
  width: 40px;
  height: 20px;
  border-radius: 10px;
  padding: 0 0.5px;

  box-shadow: inset 0 0.8px 6px rgba(0, 0, 0, 0.1),
    inset 0 0.8px 0.8px rgba(0, 0, 0, 0.1),
    inset 0 -0.4px 0.4px rgba(0, 0, 0, 0.1);

  position: relative;

  display: flex;
  align-items: center;

  cursor: pointer;
}

.btn_icon_container {
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.btn_indicator {
  background-color: var(--dark-color);
  width: 18px;
  height: 18px;
  border-radius: 50%;

  position: absolute;

  box-shadow: 0 0.8px 4px rgba(0, 0, 0, 0.2);

  transition: transform 0.3s ease;
}
.btn_icon {
  color: var(--light-icon-color);
  font-size: 10px;
}

.btn_icon.animated {
  animation: spin 0.5s;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

body.dark_mode {
  background-color: var(--dark-color);
  color: white;
}
.dark_mode > html > body {
  background-color: var(--dark-color);
  color: white;
}
.dark_mode > html > body >p>span{
  color: white;
}


.dark_mode_dm_btn {
  box-shadow: inset 0 0.8px 6px rgba(0, 0, 0, 0.3),
    inset 0.8px 0 0.8px rgba(0, 0, 0, 0.3),
    inset 0 -0.4px 0.4px rgba(0, 0, 0, 0.3);
  background-color: #fff !important;
  width: 40px;
  height: 20px;
  border-radius: 10px;
  padding: 0 0.5px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dark_mode_btn_indicator {
  transform: translateX(20px);
  background-color: var(--dark-color);
  box-shadow: 0 0.8px 4px rgba(0, 0, 0, 0.3);
  width: 18px;
  height: 18px;
  border-radius: 50%;
  position: absolute;
  transition: transform 0.3s ease;
}

.dark_mode_btn_icon_color {
  color: var(--dark-icon-color) !important;
}
.dark_mode_card {
  background-color: #2d2d2d !important;
}
.dark_mode_text {
  color: white !important;
}
.light_mode_text {
  color: #fff !important;
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
}
@media only screen and (min-width: 1024px) and (max-width: 1439px) {
}
@media only screen and (min-width: 1440px) and (max-width: 1999px) {
  .dm_btn {
    width: 55px;
    height: 25px;
    border-radius: 12px;
  }

  .btn_icon_container {
    width: 100%;
    height: 100%;
  }

  .btn_indicator {
    width: 25px;
    height: 25px;
  }
  .btn_icon {
    font-size: 15px;
  }
  .dark_mode_dm_btn {
    width: 55px;
    height: 25px;
    padding: 0 10.5px;
  }

  .dark_mode_btn_indicator {
    width: 25px;
    height: 25px;
  }
}
@media only screen and (min-width: 2000px) and (max-width: 2559px) {
  .dm_btn {
    width: 55px;
    height: 25px;
    border-radius: 12px;
  }

  .btn_icon_container {
    width: 100%;
    height: 100%;
  }

  .btn_indicator {
    width: 25px;
    height: 25px;
  }
  .btn_icon {
    font-size: 15px;
  }
  .dark_mode_dm_btn {
    width: 55px;
    height: 25px;
    padding: 0 10.5px;
  }

  .dark_mode_btn_indicator {
    width: 25px;
    height: 25px;
  }
}
@media only screen and (min-width: 2560px) {
  .dm_btn {
    width: 55px;
    height: 25px;
    border-radius: 12px;
  }

  .btn_icon_container {
    width: 100%;
    height: 100%;
  }

  .btn_indicator {
    width: 25px;
    height: 25px;
  }
  .btn_icon {
    font-size: 15px;
  }
  .dark_mode_dm_btn {
    width: 55px;
    height: 25px;
    padding: 0 10.5px;
  }

  .dark_mode_btn_indicator {
    width: 25px;
    height: 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/dark_mode_button.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;;EAEhB;;2CAEyC;;EAEzC,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB,kBAAkB;;EAElB,0CAA0C;;EAE1C,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,YAAY;AACd;;;AAGA;EACE;;2CAEyC;EACzC,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;AACA;AACA;AACA;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[":root {\n  --dark-color: #2b2b2b;\n  --dark-icon-color: #fff;\n  --light-color: #f7f7f7;\n  --light-icon-color: #ffde59;\n}\n\n.dm_btn {\n  background-color: #fff !important;\n  width: 40px;\n  height: 20px;\n  border-radius: 10px;\n  padding: 0 0.5px;\n\n  box-shadow: inset 0 0.8px 6px rgba(0, 0, 0, 0.1),\n    inset 0 0.8px 0.8px rgba(0, 0, 0, 0.1),\n    inset 0 -0.4px 0.4px rgba(0, 0, 0, 0.1);\n\n  position: relative;\n\n  display: flex;\n  align-items: center;\n\n  cursor: pointer;\n}\n\n.btn_icon_container {\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.btn_indicator {\n  background-color: var(--dark-color);\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n\n  position: absolute;\n\n  box-shadow: 0 0.8px 4px rgba(0, 0, 0, 0.2);\n\n  transition: transform 0.3s ease;\n}\n.btn_icon {\n  color: var(--light-icon-color);\n  font-size: 10px;\n}\n\n.btn_icon.animated {\n  animation: spin 0.5s;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nbody.dark_mode {\n  background-color: var(--dark-color);\n  color: white;\n}\n.dark_mode > html > body {\n  background-color: var(--dark-color);\n  color: white;\n}\n.dark_mode > html > body >p>span{\n  color: white;\n}\n\n\n.dark_mode_dm_btn {\n  box-shadow: inset 0 0.8px 6px rgba(0, 0, 0, 0.3),\n    inset 0.8px 0 0.8px rgba(0, 0, 0, 0.3),\n    inset 0 -0.4px 0.4px rgba(0, 0, 0, 0.3);\n  background-color: #fff !important;\n  width: 40px;\n  height: 20px;\n  border-radius: 10px;\n  padding: 0 0.5px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.dark_mode_btn_indicator {\n  transform: translateX(20px);\n  background-color: var(--dark-color);\n  box-shadow: 0 0.8px 4px rgba(0, 0, 0, 0.3);\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  position: absolute;\n  transition: transform 0.3s ease;\n}\n\n.dark_mode_btn_icon_color {\n  color: var(--dark-icon-color) !important;\n}\n.dark_mode_card {\n  background-color: #2d2d2d !important;\n}\n.dark_mode_text {\n  color: white !important;\n}\n.light_mode_text {\n  color: #fff !important;\n}\n@media only screen and (min-width: 768px) and (max-width: 1023px) {\n}\n@media only screen and (min-width: 1024px) and (max-width: 1439px) {\n}\n@media only screen and (min-width: 1440px) and (max-width: 1999px) {\n  .dm_btn {\n    width: 55px;\n    height: 25px;\n    border-radius: 12px;\n  }\n\n  .btn_icon_container {\n    width: 100%;\n    height: 100%;\n  }\n\n  .btn_indicator {\n    width: 25px;\n    height: 25px;\n  }\n  .btn_icon {\n    font-size: 15px;\n  }\n  .dark_mode_dm_btn {\n    width: 55px;\n    height: 25px;\n    padding: 0 10.5px;\n  }\n\n  .dark_mode_btn_indicator {\n    width: 25px;\n    height: 25px;\n  }\n}\n@media only screen and (min-width: 2000px) and (max-width: 2559px) {\n  .dm_btn {\n    width: 55px;\n    height: 25px;\n    border-radius: 12px;\n  }\n\n  .btn_icon_container {\n    width: 100%;\n    height: 100%;\n  }\n\n  .btn_indicator {\n    width: 25px;\n    height: 25px;\n  }\n  .btn_icon {\n    font-size: 15px;\n  }\n  .dark_mode_dm_btn {\n    width: 55px;\n    height: 25px;\n    padding: 0 10.5px;\n  }\n\n  .dark_mode_btn_indicator {\n    width: 25px;\n    height: 25px;\n  }\n}\n@media only screen and (min-width: 2560px) {\n  .dm_btn {\n    width: 55px;\n    height: 25px;\n    border-radius: 12px;\n  }\n\n  .btn_icon_container {\n    width: 100%;\n    height: 100%;\n  }\n\n  .btn_indicator {\n    width: 25px;\n    height: 25px;\n  }\n  .btn_icon {\n    font-size: 15px;\n  }\n  .dark_mode_dm_btn {\n    width: 55px;\n    height: 25px;\n    padding: 0 10.5px;\n  }\n\n  .dark_mode_btn_indicator {\n    width: 25px;\n    height: 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
